module.exports = "<ss-multiselect-dropdown\r\n  [options]=\"adminUnits\"\r\n  [(ngModel)]=\"selectedAdminUnits\"\r\n  [texts]=\"myTexts\"\r\n  [settings]=\"mySettings\"\r\n  (ngModelChange)=\"onChange($event)\">\r\n</ss-multiselect-dropdown>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/crm/components/admin-unit-multi-select/admin-unit-multi-select.component.html
// module id = ./src/app/crm/components/admin-unit-multi-select/admin-unit-multi-select.component.html
// module chunks = main